import { cva, css } from "../../../styled-system/css";

export const styles = {
  container: (noPaddingMobile?: boolean, noPaddingDesktop?: boolean) =>
    css({
      margin: "0 auto",
      maxWidth: "1200px",
      paddingLeft: noPaddingMobile ? 0 : "baseUnit.mobile2",
      paddingRight: noPaddingMobile ? 0 : "baseUnit.mobile2",
      desktop: {
        paddingLeft: noPaddingDesktop ? 0 : "baseUnit.mobile3",
        paddingRight: noPaddingDesktop ? 0 : "baseUnit.mobile3",
      },
    }),
};

export const containerVariants = cva({
  variants: {
    top: {
      standard: {
        paddingTop: "baseUnit.mobile4",
        desktop: {
          paddingTop: "baseUnit.mobile6",
        },
      },
      medium: {
        paddingTop: "baseUnit.mobile5",
        desktop: {
          paddingTop: "baseUnit.mobile6",
        },
      },
      large: {
        paddingTop: "baseUnit.mobile8",
      },
      none: {
        paddingTop: 0,
      },
    },
    bottom: {
      standard: {
        paddingBottom: "baseUnit.mobile6",
        desktop: {
          paddingBottom: "baseUnit.mobile4",
        },
      },
      medium: {
        paddingBottom: "baseUnit.mobile4",
        desktop: {
          paddingBottom: "baseUnit.mobile5",
        },
      },
      large: {
        paddingBottom: "baseUnit.mobile8",
      },
      single: {
        desktop: {
          paddingBottom: "baseUnit.mobile5",
        },
      },
      none: {
        paddingBottom: 0,
      },
    },
  },
  defaultVariants: {},
});
